import { createAction, props } from '@ngrx/store';
import { Lead } from '@shared/models/lead';

export const createLead = createAction('[Leads] Create Lead', props<{ lead: Partial<Lead> }>());

export const createLeadSuccess = createAction('[Leads] Create Lead Success', props<{ lead: Lead }>());

export const createLeadFailure = createAction('[Leads] Create Lead Failure', props<{ error: any }>());
